import NavbarComponent from './components/Navbar';
import Footer from './components/Footer';
import TimeoutModal from './components/TimeoutModal';
import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import Home from './pages/home/Home';
import About from './pages/about/About';
import Contact from './pages/contact/Contact';
import Service from './pages/services/Service';
import Signin from './pages/Login/Signin';
import Signup from './pages/Signup/Signup';
import ResetPassword from './pages/Login/ResetPassword';
import UserDashboard from './pages/UserPage/userdashboard';
import AdminDashboard from './pages/AdminPage/AdminDashboard';
import ApplicantForm from './forms/ApplicantForm';
import Request from './pages/makerequest/Request';
import ScrollToTop from './components/ScrollToTop';
import { BrowserRouter as Router } from 'react-router-dom';

// Import the nested components
import Settings from './pages/UserPage/Settings';
import Candidates from './pages/UserPage/Candidates';
import Payment from './pages/UserPage/Payment';
import Profile from './pages/UserPage/Profile';

// Enhanced Protected Route Component
const ProtectedRoute = ({ children, roles = [] }) => {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return <div>Loading...</div>;
  }

  if (!user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (roles.length > 0 && !roles.includes(user.role)) {
    // Redirect to appropriate dashboard based on role
    return <Navigate to={user.role === 'admin' ? '/admin' : '/userdashboard'} replace />;
  }

  return children;
};

// Special route for token-based access
const TokenProtectedRoute = ({ children }) => {
  const query = new URLSearchParams(window.location.search);
  const token = query.get('token');
  const candidateEmail = query.get('candidateEmail');
  const companyId = query.get('companyId');

  return token && candidateEmail && companyId ? children : <Navigate to="/" replace />;
};

const AppContent = () => {
  const { loading } = useAuth();

  if (loading) {
    return (
      <div className="bg-white min-vh-100 d-flex flex-column">
        <NavbarComponent />
        <div className="flex-grow-1 d-flex justify-content-center align-items-center">
          <div>Loading application...</div>
        </div>
        <Footer />
      </div>
    );
  }

  return (
    <div className="bg-white min-vh-100 d-flex flex-column">
      <NavbarComponent />
      <div className="flex-grow-1">
        <Routes>
          {/* Public Routes */}
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/service" element={<Service />} />
          <Route path="/login" element={<Signin />} />
          <Route path="/signup" element={<Signup />} />
          <Route path="/reset-password" element={<ResetPassword />} />

          {/* Token-protected route */}
          <Route
            path="/applicantform"
            element={
              <TokenProtectedRoute>
                <ApplicantForm />
              </TokenProtectedRoute>
            }
          />

          {/* User Dashboard with nested routes */}
          <Route
            path="/userdashboard/*"
            element={
              <ProtectedRoute roles={['user', 'manager', 'admin']}>
                <UserDashboard />
              </ProtectedRoute>
            }
          >
            <Route path="settings" element={<Settings />} />
            <Route path="candidates" element={<Candidates />} />
            <Route path="payment" element={<Payment />} />
            <Route path="profile" element={<Profile />} />
            <Route path="contactUs" element={<Contact />} />
            <Route index element={<Navigate to="profile" replace />} />
          </Route>

          {/* Admin Dashboard */}
        <Route
            path="/admin"
            element={
              <ProtectedRoute roles={['admin']}>
                <AdminDashboard />
              </ProtectedRoute>
          }
        >
          <Route path="clients" element={null} />
          <Route path="candidates" element={null} />
          <Route index element={null} />
        </Route>
            

          {/* Request Page */}
          <Route
            path="/makerequest"
            element={
              <ProtectedRoute roles={['user', 'manager', 'admin']}>
                <Request />
              </ProtectedRoute>
            }
          />

          {/* Catch-all route */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </div>
      <Footer />
      <TimeoutModal />
    </div>
  );
};

const App = () => {
  return (
    <Router>
      <AuthProvider>
      <ScrollToTop />
        <AppContent />
      </AuthProvider>
    </Router>
  );
};

export default App;